import { render, staticRenderFns } from "./ClinicQuotations.vue?vue&type=template&id=0d0fbb1a"
import script from "./ClinicQuotations.vue?vue&type=script&lang=js"
export * from "./ClinicQuotations.vue?vue&type=script&lang=js"
import style0 from "./ClinicQuotations.vue?vue&type=style&index=0&id=0d0fbb1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports